<template>
  <div class="home">
    <navbar :is-active="6"></navbar>
    <div class="body form-page-body">
      <MesasSidebar active="mesas" />
      <div class="body__containt form-page-content">
        <div class="page__title form-page-title">
          <open-arrow></open-arrow>
          <div class="page__title-text">
            <h2>Nueva mesa</h2>
            <p class="page__lead">Registra una mesa para generar su QR y asignarle menú desde POS.</p>
          </div>
        </div>

        <form class="form-card" @submit.prevent="save">
          <div class="form-card__header">
            <div class="form-card__icon">
              <i class="fas fa-chair"></i>
            </div>
            <div>
              <h3>Datos de la mesa</h3>
              <p>Los campos con * son obligatorios.</p>
            </div>
          </div>

          <div class="form-grid">
            <label class="field" :class="{ 'field--error': activeClass && !table_number }">
              <span class="field__label">Número de mesa *</span>
              <input type="text" v-model="table_number" maxlength="10" @keypress="onlynumber" placeholder="Ej. 1">
              <span class="field__hint" v-if="activeClass && !table_number">Ingresa el número</span>
            </label>

            <label class="field" :class="{ 'field--error': activeClass && !table_name }">
              <span class="field__label">Nombre de mesa *</span>
              <input type="text" v-model="table_name" maxlength="150" placeholder="Ej. Mesa terraza">
              <span class="field__hint" v-if="activeClass && !table_name">Ingresa el nombre</span>
            </label>

            <div class="field">
              <span class="field__label">Estado</span>
              <div class="status-toggle">
                <button type="button" :class="{ active: table_status === '1' }" @click="table_status = '1'">Activa</button>
                <button type="button" :class="{ active: table_status === '0' }" @click="table_status = '0'">Inactiva</button>
              </div>
            </div>

            <label class="field field--full">
              <span class="field__label">Descripción <em>(opcional)</em></span>
              <textarea v-model="table_description" rows="3" placeholder="Ubicación, capacidad u observaciones"></textarea>
            </label>
          </div>

          <div class="meta-row">
            <div class="meta-item">
              <span>UUID</span>
              <strong>Se genera al guardar</strong>
            </div>
            <div class="meta-item">
              <span>Fecha de registro</span>
              <strong>{{ hoy }}</strong>
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="btn btn--ghost" @click="cancel" :disabled="saving">
              <i class="fa fa-times"></i> Cancelar
            </button>
            <button type="submit" class="btn btn--primary" :disabled="saving">
              <i class="fa fa-check"></i> {{ saving ? 'Guardando...' : 'Guardar mesa' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Navbar from '@/components/NavBar.vue'
import MesasSidebar from '@/components/MesasSidebar.vue'
import OpenArrow from '@/components/OpenArrow.vue'
import '@/static/css/form-card.css'

export default {
  name: 'AddMesa',
  components: {
    Navbar,
    MesasSidebar,
    OpenArrow
  },
  data() {
    return {
      table_name: '',
      table_number: '',
      table_description: '',
      table_status: '1',
      activeClass: false,
      saving: false,
      hoy: new Date().toISOString().slice(0, 10)
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/login')
    }
  },
  methods: {
    onlynumber(evt) {
      evt = evt || window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      }
    },
    cancel() {
      this.$router.push('/mesas')
    },
    async save() {
      if (!this.table_name || !this.table_number) {
        this.activeClass = true
        this.$swal({
          icon: 'error',
          title: 'Completar los datos correctamente',
          showConfirmButton: false,
          timer: 2000
        })
        return
      }

      this.saving = true
      const data = {
        table_name: this.table_name,
        table_number: parseInt(this.table_number, 10),
        table_description: this.table_description || null,
        table_status: parseInt(this.table_status, 10),
        table_company_id: parseInt(localStorage.getItem('company_id'), 10)
      }

      try {
        const res = await axios.post('general/table', data)
        if (res.data.success) {
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'Mesa creada correctamente',
            showConfirmButton: false,
            timer: 2000
          })
          this.$router.push('/mesas')
        } else {
          this.$swal({
            icon: 'error',
            title: res.data.message || 'Ocurrio un error',
            showConfirmButton: false,
            timer: 2500
          })
        }
      } catch (e) {
        const message = (e.response && e.response.data && e.response.data.message)
          ? e.response.data.message
          : 'Ocurrio un error'
        this.$swal({
          icon: 'error',
          title: message,
          showConfirmButton: false,
          timer: 2500
        })
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
